import { type FunctionComponent, useMemo } from 'react';

import { getSnapAlignStyle } from './slideUtils';
import styles from './FavoritesCarouselSnap.module.scss';

interface SlidePlaceholderProps {
  index: number;
  snapPointIndexes: Set<number>;
}

/** Lightweight placeholder that preserves scroll-snap layout without mounting the camera player. */
const SlidePlaceholder: FunctionComponent<SlidePlaceholderProps> = ({
  index,
  snapPointIndexes,
}) => {
  const listItemStyle = useMemo(
    () => getSnapAlignStyle(index, snapPointIndexes),
    [index, snapPointIndexes],
  );

  return (
    <li
      aria-hidden
      className={styles.item}
      data-testid="favorites-carousel-snap-placeholder"
      style={listItemStyle}
    >
      <div className={styles.placeholder} />
    </li>
  );
};

export default SlidePlaceholder;
